import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useApolloClient } from '@apollo/client/react'
import { useIonRouter } from '@ionic/react'
import { Capacitor } from '@capacitor/core'
import { registerPushNotifications } from '../utils/pushNotifications'

/**
 * Installs push notification listeners and synchronizes the current device token
 * whenever the native app starts with an authenticated session.
 */
export const PushNotificationInitializer = () => {
  const { isAuthenticated, isLoading } = useAuth0()
  const apolloClient = useApolloClient()
  const ionRouter = useIonRouter()

  useEffect(() => {
    if (
      isLoading ||
      !isAuthenticated ||
      !Capacitor.isNativePlatform() ||
      localStorage.getItem('pushNotificationsDisabled') === 'true'
    ) {
      return
    }

    registerPushNotifications({
      apolloClient,
      navigate: (path) => ionRouter.push(path, 'forward'),
    }).catch((error) => {
      console.error('[PushNotifications] Initialization failed:', error)
    })
  }, [isAuthenticated, isLoading, apolloClient, ionRouter])

  return null
}
